/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/quotes */
import type { SVGProps } from "react";
const SvgCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color ?? 'currentColor'}
    viewBox="0 0 12 9"
    {...props}
  >
    <path
      d="M11.138.861c.26.26.26.683 0 .943L4.471 8.471a.667.667 0 0 1-.942 0L.195 5.137a.667.667 0 0 1 .943-.942L4 7.057 10.195.86c.26-.26.683-.26.943 0"
    />
  </svg>
);
export default SvgCheckIcon;
